import styled from 'styled-components';

export const Conteiner = styled.div<any> `
  position: relative;
  transform: none;
  display:flex;
  align-items:center;
  gap:12px;
  margin: 0 auto;
  margin-bottom: 15px;
  padding:10px 14px;
  border-radius:9999px;
  background: linear-gradient(90deg, ${props => props.primary || '#D2BD75 '} 0%, ${props => props.secondary || '#27446E80'} 100%);
  box-shadow: 0 8px 20px rgba(0,0,0,0.15);
  z-index:999;

  .reactions {
    display:flex;
    gap:10px;
  }
  .reactions img {
    width:32px;
    height:32px;
    border-radius:50%;
    transition: transform 120ms ease, filter 120ms ease;
    cursor: pointer;
    filter: drop-shadow(0 2px 4px rgba(0,0,0,0.12));
    position: relative;
  }
  .reactions img:hover {
    transform: translateY(-1px) scale(1.5);
  }
  .reactions img.clicked {
    animation: popGlow 380ms ease;
  }
  .reactions img.clicked::after {
    content: '';
    position:absolute;
    top:50%;
    left:50%;
    width:15px;
    height:15px;
    border-radius:9999px;
    box-shadow: 0 0 0 0 rgba(255,255,255,0.65);
    transform: translate(-50%, -50%);
    animation: ring 450ms ease;
    pointer-events:none;
  }
  .likes {
    display:flex;
    align-items:center;
    gap:8px;
    padding:8px 12px;
    border-radius:9999px;
    background: rgba(255,255,255,0.95);
    border: 1px solid rgba(255,255,255,0.4);
    color:#fff;
    font-size:14px;
    line-height:1;
    margin-right: 8px;
    position: relative;
    
    /* separador sutil */
    &::after {
      content: '';
      position: absolute;
      right: -11px;
      top: 50%;
      transform: translateY(-50%);
      width: 1px;
      height: 20px;
      background: rgba(255,255,255,0.3);
    }
  }
  .likes .icon-like {
    width:20px;
    height:20px;
    filter: brightness(0) saturate(100%) invert(20%) sepia(15%) saturate(3000%) hue-rotate(200deg) brightness(95%) contrast(90%);
  }
  .likes .count-like {
    color: #213155;
    font-weight: 600;
    font-size: 15px;
  }

  @keyframes popGlow {
    0%   { transform: translateY(0) scale(1); }
  25%  { transform: translateY(-6px) scale(1.15); }
  50%  { transform: translateY(3px) scale(1.1); }
  75%  { transform: translateY(-4px) scale(1.08); }
  100% { transform: translateY(0) scale(1); }
  }

  @keyframes ring {
    0% { box-shadow: 0 0 0 0 rgba(255,255,255,0.65); opacity:1; }
    100% { box-shadow: 0 0 0 16px rgba(255,255,255,0); opacity:0; }
  }

  /* efeitos decorativos removidos para um visual mais simples */

  @media (max-width: 767px) {
    gap:10px;
    .reactions img {
      width:26px;
      height:26px;
    }
  }
`;

